// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_5079b8e2","heart":"_95c9e270","folder":"_1c4266cc"};